import axios from 'axios';
import { Nullable } from 'modules/types/common';

import Config from 'react-native-config';
import Logger from 'services/Logger';
import { Specialty } from 'store/booking/types';
import { ProviderLocation, ProviderSummary } from 'store/findProvider/types';

const googleMapsAxiosClient = axios.create({
  baseURL: Config.GOOGLE_GEOCODE_ENDPOINT,
  responseType: 'json',
  timeout: Config.REQUEST_TIMEOUT_DURATION || 60000
});

interface Location {
  formattedAddress: string;
  coords: {
    latitude: number;
    longitude: number;
  };
}

export const getLocationFromInput = async (input: string): Promise<Location | null> => {
  const isZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(input);

  const cleanedInput = input.replace(/\s+/g, '+').replace(/\.+/g, '');
  const type = isZip ? 'components=postal_code:' : 'address';
  const utahBounds = '37.054288,-114.877739|43.848857,-109.511853';

  try {
    const { data } = await googleMapsAxiosClient.get(
      `/json?${type}=${cleanedInput}&bounds=${utahBounds}&key=${Config.GOOGLE_GEOCODE_KEY}`
    );
    const { results } = data;
    if (results && results.length) {
      const result = results[0];
      const coords = result.geometry.location;

      return {
        formattedAddress: result.formatted_address,
        coords: {
          latitude: coords.lat,
          longitude: coords.lng
        }
      };
    }

    Logger.warn('getLocationFromInput: No results for location', input);
    return null;
  } catch (e) {
    Logger.error('getLocationFromInput: Failed to get location', e);
    return null;
  }
};

/**
 * @description returns true if geolocation is actived, distance prop exists,
 * is not virtual clinic only and specialty is neither Virtual Primary Care nor
 * Behavioral Health Connect Care
 */
export function showDistance(
  location: ProviderLocation | ProviderSummary,
  specialty: Nullable<Specialty>,
  geoLocationStatus?: boolean
): boolean {
  return (
    (geoLocationStatus ?? false) &&
    !!location?.distance &&
    location?.isVirtualClinic === false &&
    !specialty?.nameShort.includes('P|PS|PSY') &&
    !specialty?.nameShort.includes('TBD')
  );
}
